import type { ComponentProps } from "react";

import useUniqueId from "hooks/use-unique-id";

import { TextField as MuiTextField } from "components/core/mui";

/**
 * A tiny wrapper that simply sets a random ID on the `TextField` if one is not provided.
 * This is necessary so that the label is tied to the input.
 *
 * #### Links
 *
 * - [https://mui.com/components/text-fields/](https://mui.com/components/text-fields/)
 */
type Props = ComponentProps<typeof MuiTextField> & {
  /**
   * A custom ID for the underlying select input and label. Will default to a randomly
   * generated ID if not provided.
   */
  id?: string;
};

const TextField = ({ id, ...rest }: Props) => {
  const inputId = useUniqueId(id);

  return <MuiTextField id={inputId} {...rest} />;
};

export default TextField;
